const getPrescriberAddress = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    if (address.Apt) {
      return `${address.Street} ST. APT. ${address.Apt}`.toUpperCase();
    } else if (address.Street) {
      return `${address.Street} ST.`.toUpperCase();
    }
    return null;
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    if (address.Apt) {
      return `${address.Street} ST. APT. ${address.Apt}`.toUpperCase();
    } else if (address.Street) {
      return `${address.Street} ST.`.toUpperCase();
    }
    return null;
  }
  return null;
};

export default getPrescriberAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberAddress.js